var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.121 10.379C17.5584 9.81662 16.7955 9.50067 16 9.50067C15.2045 9.50067 14.4416 9.81662 13.879 10.379",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.95 7.55002C20.3 6.89993 19.5283 6.38425 18.6789 6.03242C17.8296 5.6806 16.9193 5.49951 16 5.49951C15.0807 5.49951 14.1704 5.6806 13.321 6.03242C12.4717 6.38425 11.7 6.89993 11.05 7.55002",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.5V20.5L19 17.5L14 14.5Z",
    fill: "#212121"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.5H7C6.46957 9.5 5.96086 9.71071 5.58579 10.0858C5.21071 10.4609 5 10.9696 5 11.5V23.5C5 24.0304 5.21071 24.5391 5.58579 24.9142C5.96086 25.2893 6.46957 25.5 7 25.5H25C25.5304 25.5 26.0391 25.2893 26.4142 24.9142C26.7893 24.5391 27 24.0304 27 23.5V11.5C27 10.9696 26.7893 10.4609 26.4142 10.0858C26.0391 9.71071 25.5304 9.5 25 9.5H24",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveVideo);
export default __webpack_public_path__ + "static/media/LiveVideo.0f20b1da2f8498c33d53eebbc9da84a9.svg";
export { ForwardRef as ReactComponent };